<div class="nothing-found-wrap">
  <div class="card">
    <img src="assets/images/emojis/1f440.svg" class="h-9" alt="Nothing Found emoji" />
    <p>{{ hintMessageKey | translate }}</p>
  </div>
</div>
